module.exports = __webpack_public_path__ + "img/zm_zaixiankaifang@3x.57dc8b13.png";